import React, { Component } from 'react';
import PropTypes from 'prop-types';

// NOTE: right now this component is only available as a Controlled Component.
// It has no internal state and will not toggle when used by itself.
// This is something we can change, so it can be used by itself as a Simple Form
// input.
// More info: https://facebook.github.io/react/docs/forms.html#controlled-components

export default class Checkbox extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    className: PropTypes.string,
    value: PropTypes.string,
    name: PropTypes.string,
    checked: PropTypes.bool,
    indeterminate: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltipText: PropTypes.string,
    onChange: PropTypes.func,
    wrapperClassName: PropTypes.string,
  }

  static defaultProps = {
    name: '',
    value: '',
    checked: false,
    disabled: false,
    indeterminate: false,
    tooltipText: undefined,
    onChange: undefined,
    className: undefined,
    wrapperClassName: undefined,
  }

  tooltipProps() {
    if (this.props.tooltipText === undefined) { return {}; }
    return { 'data-tooltip': '', title: this.props.tooltipText };
  }

  classNames() {
    const classNames = [];
    if (this.props.indeterminate) { classNames.push('is-indeterminate'); }
    if (this.props.className) { classNames.push(this.props.className); }
    return classNames.join(' ');
  }

  render() {
    return (
      <div className={`checkbox ${this.props.wrapperClassName ? this.props.wrapperClassName : ''}`}>
        <label htmlFor={this.props.id} className={this.classNames()} {...this.tooltipProps()}>
          <input
            type="checkbox"
            name={this.props.name}
            value={this.props.value}
            id={this.props.id}
            onChange={this.props.onChange}
            checked={this.props.checked}
            disabled={this.props.disabled}
            readOnly={this.props.onChange === undefined}
          />
          {this.props.children}
        </label>
      </div>
    );
  }
}
